import React from "react";
import { FormattedMessage } from "react-intl";
import { RoleEnum } from "../types/RoleEnum";
export var navigation = {
    myProfile: {
        path: "/brusers/my-profile",
        label: React.createElement(FormattedMessage, { id: "ui-br-users.navigation.my-profile" }),
    },
    organizations: {
        path: "/brusers/organizations",
        label: React.createElement(FormattedMessage, { id: "ui-br-users.navigation.organizations" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    users: {
        path: "/brusers/users",
        label: React.createElement(FormattedMessage, { id: "ui-br-users.navigation.users" }),
        roles: [RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN, RoleEnum.ADMIN_LEGAL_DEPOSITS],
    },
    adminEnvironmentVariables: {
        path: "/brusers/admin/environment-variables",
        label: React.createElement(FormattedMessage, { id: "ui-br-users.navigation.admin" }),
        roles: [RoleEnum.SUPERUSER],
    },
    // #Navigation
};
